import { apiResourceUrl } from "@ploy-lib/core";
import { BaseCamelCasedResource } from "./BaseResource";
export class TableTypeResource extends BaseCamelCasedResource {
    constructor() {
        super(...arguments);
        this.dataSources = [];
    }
    pk() {
        return this.displayName || "";
    }
}
TableTypeResource.urlRoot = apiResourceUrl("tableType");
//# sourceMappingURL=TableTypeResource.js.map